module.exports = __webpack_public_path__ + "img/4door_parked.7100212a.svg";